import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { PictureSets } from "../../models/pictureSets";
import { ProgramArticlePictureETTValue } from "../../models/program-article-translation-value";

export const ADDITIONAL_PICTURES_ACTIONS = {
  SET_ADDITIONAL_PICTURES: "SET_ADDITIONAL_PICTURES",
  UPDATE_ADDITIONAL_PICTURES: "UPDATE_ADDITIONAL_PICTURES",
  DELETE_ADDITIONAL_PICTURES: "DELETE_ADDITIONAL_PICTURES",
};

export interface AdditionalPicturesStateInterface {
  pictureSets: PictureSets;
}

@Injectable()
export class AdditionalPicturesActions {
  constructor(private store: Store<AdditionalPicturesStateInterface>) {}

  setAdditionalPictures(pictureSets: PictureSets) {
    this.store.dispatch({
      type: ADDITIONAL_PICTURES_ACTIONS.SET_ADDITIONAL_PICTURES,
      payload: pictureSets,
    });
  }

  updateAdditionalPictures(
    pictures: ProgramArticlePictureETTValue[],
    setId: number,
    format: string
  ) {
    this.store.dispatch({
      type: ADDITIONAL_PICTURES_ACTIONS.UPDATE_ADDITIONAL_PICTURES,
      payload: { pictures: pictures, format: format, setId: setId },
    });
  }

  deleteAdditionalPictures(setId: number) {
    this.store.dispatch({
      type: ADDITIONAL_PICTURES_ACTIONS.DELETE_ADDITIONAL_PICTURES,
      payload: { setId: setId },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/additional-pictures.actions.ts